import { StepsContext } from '@context/stepsContext'
import { useContext } from 'react'

export function useSteps() {
  return useContext(StepsContext)
}
